import { DonneeAnalyse } from "./donneeAnalyse";
import { Exploitation } from "./hiboo/exploitation";
import { Projet } from "./projet";
import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { Rotation } from "./rotation";
import { TypeTir } from "./TypeTir";
import { Vibration } from "./vibration";
import { WorkflowInstance } from "./workflowInstance";
import { Zone } from "./zone";

export class Tir {
  tirId: number;
  nom: string;
  dateTirPrevisionnelle: Date;
  dateTirEffective: Date;
  projetId: number;
  siteId: number;
  zoneId: number;
  zone: Zone;
  niveau: string;
  projet: Projet;
  workflowInstance: WorkflowInstance;
  rotations: Rotation[];
  donneeAnalyses: DonneeAnalyse[];
  vibrations: Vibration[];
  estRealise: boolean;
  nomProjet: string;
  nomZone: string;
  donneeAnalyseRenseignees: boolean;
  estSupprimable: boolean;
  typeTirId: number;
  typeTir: TypeTir;
  nomTypeTir: string;
  dateFinProjet: Date;
  dateFinPrevisionnelleProjet: Date;
  blasted: number;
  kpiIsVerified: boolean;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('estRealise', 'GLOBAL.EST_REALISE', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check', '')));
    tab.push(new ProprieteAffichee('nomProjet', 'GLOBAL.PROJET'));
    tab.push(new ProprieteAffichee('nomZone', 'GLOBAL.ZONE'));
    tab.push(new ProprieteAffichee('dateTirPrevisionnelle', 'TIR.DATE_PREV', '', new CustomAffichage(TypePropriete.Date)));
    tab.push(new ProprieteAffichee('dateTirEffective', 'TIR.DATE_EFF', '', new CustomAffichage(TypePropriete.Date)));
    return tab;
  }

  static GetBestDate(tir: Tir): Date {
    if (null == tir || undefined == tir) return null;

    if (undefined !== tir.dateTirEffective && null !== tir.dateTirEffective) return tir.dateTirEffective;
    else return tir.dateTirPrevisionnelle;
  }


}



export interface TirInterface {
  tirId: number;
  nom: string;
  nomProjet: string;
  nomZone: string;
  isChecked?:boolean;
  exploitation?:Exploitation



}